import { prepareHTTPConfig } from './httpConfig';
import errorHandler from './errorHandler';
import getConfig from 'next/config';
import { GraphQLClient } from 'graphql-request';
import { GraphQLResponse } from 'graphql-request/dist/types';
import fetch from 'node-fetch';
const { WPGRAPHQL_URL } = getConfig().publicRuntimeConfig;

export const HTTPClient = async (URL, req) => {
  let response;

  const httpOptions: RequestInit = prepareHTTPConfig(req);
  try {
    const res = await fetch(URL, httpOptions);
    response = await res.json();
  } catch (err) {
    response = errorHandler(err.response);
  }

  return response;
};

export const graphqlFetcher = async (query, variables = {}, targetURL = '', options = {}) => {
  const URL = targetURL ? targetURL : WPGRAPHQL_URL;
  const graphqlClient = new GraphQLClient(URL, options);
  try {
    const response = await graphqlClient.request<GraphQLResponse>(query, variables);
    return {
      data: response,
      errors: null,
      status: 200,
    };
  } catch (err) {
    return {
      data: null,
      errors: err.response
        ? errorHandler(err.response)
        : `Internal server error: ${err.type && err.type === 'system' && err.code && err.code}`,
      status: 500,
    };
  }
};
